import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError } from '../../../interfaces/apiResponse.type';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';

export const useInitiateShopify = () => {
  const { t } = useTranslation();

  return useMutation(
    (queryParams: string) => dataFetch.post(
      `${DIGGER_API_SUFFIX}shopify/initiate${queryParams}`,
    ),
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('storeConnectSuccess'), 'success');
      },
      onError: (error: ApiError<null>) => {
        handleApiError(error, t);
      },
    },
  );
};
